import { atomFamily, selectorFamily } from 'recoil';
import * as vodaLend from '../api/vodaLend';

export const advanceFiguresAtom = atomFamily({
  key: 'advanceFiguresAtom',
  default: selectorFamily({
    key: 'advanceFiguresAtom/default',
    get: (applicationId) => async () => {
      if (!applicationId) { return null; }
      try {
        const advance = await vodaLend.getAdvance(applicationId);

        if (!advance) {
          return advance;
        }

        return {
          advanceId:               advance.advanceId,
          advanceAmount:           advance.advanceAmount,
          arrearsAmount:           advance.arrearsAmount,
          remainingCapital:        advance.remainingCapital,
          remainingBalance:        advance.remainingBalance,
          totalRepaid:             advance.repaidAmount,
          totalOutstanding:        advance.remainingBalance,
          totalRepayments:         advance.totalRepayments,
          isReadvanceEligible:     advance.isReadvanceEligible,
          refinanceRequestedDate:  advance.refinanceRequestedDate ?? null,
          refinanceDeclinedDate:   advance.refinanceDeclinedDate ?? null
        };
      } catch {
        return null;
      }
    }
  })
});
